import { useEffect, useRef, useState } from "react";

const Adminchapterunitview = ({chapterName,unit1,unit2,unit3,unit4,unit5,unit6,unit7,unit8,unit9,unit10,chapteronly,handlechapter,handleunit}) => {
    const [droplist,setDropList]=useState(false);
    const subref = useRef();

    const getChapterName=(cname)=>{
        handlechapter(cname);
    };
    const getUnitName=(uname)=>{
        handleunit(uname);
    };

    useEffect(()=>{
        const cleardroplist =(e)=>{
            if(!subref.current.contains(e.target)){
                setDropList(false);
            }
        }
        document.addEventListener('mousedown',cleardroplist);
        return()=>{
            document.removeEventListener('mousedown',cleardroplist);
        }
    },[]);

    return ( 
        <div className="adminlocationsview" key={chapterName} ref={subref}>
            {chapteronly && <button id="chapterlistbutton" onClick={()=>getChapterName(chapteronly)}>{chapteronly}</button>}

            {chapterName && 
                <div className="flex-row2" onClick={()=>setDropList(prev => !prev)}>
                    <h3>{chapterName}</h3>
                    <svg
                    cursor="pointer"
                    viewBox="0 0 24 24"
                    fill="black"
                    height="1.5em"
                    width="1.5em">
                    <path fill="none" d="M0 0h24v24H0V0z" />
                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                    </svg>
                </div>
            }
        

            {droplist && 
                <div className="subunits flex-column2">
                    {unit1 &&  <button onClick={()=>getUnitName(unit1)}>{unit1}</button>}            
                    {unit2 && <button onClick={()=>getUnitName(unit2)}>{unit2}</button>}
                    {unit3 && <button onClick={()=>getUnitName(unit3)}>{unit3}</button>}
                    {unit4 && <button onClick={()=>getUnitName(unit4)}>{unit4}</button>}
                    {unit5 && <button onClick={()=>getUnitName(unit5)}>{unit5}</button>}
                    {unit6 && <button onClick={()=>getUnitName(unit6)}>{unit6}</button>}
                    {unit7 && <button onClick={()=>getUnitName(unit7)}>{unit7}</button>}
                    {unit8 && <button onClick={()=>getUnitName(unit8)}>{unit8}</button>}
                    {unit9 && <button onClick={()=>getUnitName(unit9)}>{unit9}</button>}
                    {unit10 && <button onClick={()=>getUnitName(unit10)}>{unit10}</button>}
                    {chapterName && <button onClick={()=>getChapterName(chapterName)}>{chapterName}</button>}
                </div>
            }
        </div>
     );
}
export default Adminchapterunitview;